import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}
const DeletedInfo = ({ label }: Props) => (
  <Alert color="warning">
    <Box flexDirection="row">
      <Icon.Medium icon="info-circle-line" color="grey800" />
      <Text.Normal>{label}</Text.Normal>
    </Box>
  </Alert>
)

export default DeletedInfo
